import React from 'react';

import { UiKit } from 'components';
import * as RefundMethodsList from './RefundMethodsList';
import { FeatureContainer } from '../../components';
import { useFTUWizard } from '../../context';

export default function RefundMethods() {
  const { onGotoNext } = useFTUWizard();

  return (
    <FeatureContainer
      title="Which refund method would you like to offer?"
      subtitle="Select and configure how customers receive their refunds."
    >
      <RefundMethodsList.Provider>
        <RefundMethodsList.List />
      </RefundMethodsList.Provider>
      <UiKit.Sheet.ActionsPortal>
        <UiKit.Button size="lg" onClick={() => onGotoNext()}>
          Continue
        </UiKit.Button>
      </UiKit.Sheet.ActionsPortal>
    </FeatureContainer>
  );
}
